import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropzone", "preview", "filename"]

  browse(event) {
    this.inputTarget.click()
  }

  preview(event) {
    const input = event.target
    const type = input.dataset.type
    
    if (input.files && input.files[0]) {
      const file = input.files[0]
      
      if (type === "document") {
        const documentSvg = document.getElementById("big-document-svg")
        const selectChangeDocumentDiv = document.getElementById("change-select-file-instruction")

        if(documentSvg && !documentSvg.classList.contains("hidden")) {
          documentSvg.classList.add("hidden")
        }

        if(selectChangeDocumentDiv && !(/Alterar arquivo/i.test(selectChangeDocumentDiv.textContent))) {
          selectChangeDocumentDiv.textContent = "Alterar arquivo"
        }

        this.previewTarget.classList.remove("hidden")
        this.previewTarget.innerHTML = `
          <div class="flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <span class="ml-2 text-sm text-green-600" data-file-preview-target="filename"></span>
          </div>
        `
        this.previewTarget.querySelector('[data-file-preview-target="filename"]').textContent = file.name
      }
    }
  }
  
  dragOver(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("border-green-400", "bg-green-50")
  }
  
  dragLeave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-green-400", "bg-green-50")
  }
  
  drop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-green-400", "bg-green-50")
    
    const file = event.dataTransfer.files[0]
    const type = this.dropzoneTarget.dataset.type
    const acceptedTypes = this.inputTarget.accept.split(',')
    
    if (file && acceptedTypes.includes(file.type)) {
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      this.inputTarget.files = dataTransfer.files
      
      const changeEvent = new Event('change', { bubbles: true })
      this.inputTarget.dispatchEvent(changeEvent)
    }
  }
}